import { FC } from 'react'
import { useTheme } from 'styled-components'
import AutocompleteSuggestion from '../../core/domain/models/AutocompleteSuggestion'
import Dropdown from './Dropdown'
import SuggestionIcon from './SuggestionIcon'

interface DropOffLocationSuggestionListProps {
  suggestions: AutocompleteSuggestion[]
  onSelect: (suggestion: AutocompleteSuggestion) => void
  loading?: boolean
}

const DropOffLocationSuggestionList: FC<DropOffLocationSuggestionListProps> = (props) => {
  const { suggestions, onSelect, loading } = props

  const theme = useTheme()
  return (
    <>
      <Dropdown<AutocompleteSuggestion>
        suggestions={suggestions.map((suggestion) => {
          const { api, description } = suggestion
          return {
            item: suggestion,
            label: description,
            icon: <SuggestionIcon stroke={theme.color.iconGray} api={api} />
          }
        })}
        onSelect={onSelect}
        loading={loading}
      />
    </>
  )
}

export default DropOffLocationSuggestionList
